import { adminInvoicesApi } from "./commerce";

/**
 * Download and preview a tax-invoice PDF from the authenticated admin API.
 *
 * Browsers only allow `window.open()` inside the synchronous user-activation
 * frame of a click handler. Because we must await the axios call to get the
 * blob, we open a blank preview window *synchronously* first, then navigate
 * it to the object URL once the blob is available.
 */
export async function downloadInvoicePdf(invoiceId, invoiceNumber) {
  // Must be called synchronously inside the click handler for the tab to open.
  const previewWin = window.open("", "_blank");
  try {
    const blob = await adminInvoicesApi.downloadPdf(invoiceId);
    const url = URL.createObjectURL(blob);

    // Also trigger a file download so the user has a copy.
    const a = document.createElement("a");
    a.href = url;
    a.download = `${invoiceNumber || "invoice"}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    if (previewWin && !previewWin.closed) {
      previewWin.location.href = url;
    } else {
      // Popup blocked — at least the download happened.
      window.open(url, "_blank");
    }
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (err) {
    if (previewWin && !previewWin.closed) previewWin.close();
    throw err;
  }
}
